import sortBy from 'lodash/sortBy';

import { frontmatter as meta1 } from 'pages/blog/session-player-layout-update';
import { frontmatter as meta2 } from 'pages/blog/new-filters-released';
import { frontmatter as meta3 } from 'pages/blog/top-users-in-segment';
import { frontmatter as meta4 } from 'pages/blog/more-date-filtering-options';
import { frontmatter as meta5 } from 'pages/blog/dashboard-filtering-and-segmentation';
import { frontmatter as meta6 } from 'pages/blog/what-is-session-replay';
import { frontmatter as meta7 } from 'pages/blog/livesession-wins-premium-usability-honor';
import { frontmatter as meta8 } from 'pages/blog/new-retention-options';
import { frontmatter as meta9 } from 'pages/blog/website-settings';
import { frontmatter as meta10 } from 'pages/blog/segment-sharing';
import { frontmatter as meta11 } from 'pages/blog/new-system-filters';
import { frontmatter as meta12 } from 'pages/blog/masking-sensitive-data';
import { frontmatter as meta13 } from 'pages/blog/mouse-movement-trace';
import { frontmatter as meta14 } from 'pages/blog/keyboard-shortcuts';
import { frontmatter as meta15 } from 'pages/blog/substring-filter';
import { frontmatter as meta16 } from 'pages/blog/mobile-actions-support';
import { frontmatter as meta17 } from 'pages/blog/how-to-use-the-owned-channels-to-generate-b2b-leads-and-boost-sales';
import { frontmatter as meta18 } from 'pages/blog/filters-redesign';
import { frontmatter as meta19 } from 'pages/blog/user-details';
import { frontmatter as meta20 } from 'pages/blog/team-management';
import { frontmatter as meta21 } from 'pages/blog/optimize-your-website-like-a-pro';
import { frontmatter as meta22 } from 'pages/blog/the-importance-of-customer-service';
import { frontmatter as meta23 } from 'pages/blog/tag-session-to-find-them-easily';
import { frontmatter as meta24 } from 'pages/blog/recording-rules';
import { frontmatter as meta25 } from 'pages/blog/why-do-people-hate-your-website';
// import { frontmatter as meta26 } from 'pages/blog/how-to-use-heat-maps-to-improve-your-page-performance';
import { frontmatter as meta27 } from 'pages/blog/clicks-rage-clicks-and-error-clicks-on-dashboard';
import { frontmatter as meta28 } from 'pages/blog/more-accurate-location-of-the-user';
import { frontmatter as meta29 } from 'pages/blog/export-to-csv-your-top-lists';
import { frontmatter as meta30 } from 'pages/blog/click-tracking-on-your-website-all-you-need-to-know';
import { frontmatter as meta31 } from 'pages/blog/your-profile-page';
import { frontmatter as meta32 } from 'pages/blog/engagement-score';
import { frontmatter as meta33 } from 'pages/blog/top-6-tools-for-improving-conversion-in-saas';
import { frontmatter as meta34 } from 'pages/blog/how-to-use-filters-in-user-research';
import { frontmatter as meta35 } from 'pages/blog/livesession-named-a-high-performer-in-session-replays-for-fall-2019-by-g2-crowd';
import { frontmatter as meta36 } from 'pages/blog/cro-trends-2020';
import { frontmatter as meta37 } from 'pages/blog/5-easy-ways-to-increase-landing-page';
import { frontmatter as meta38 } from 'pages/blog/user-frustration';
import { frontmatter as meta39 } from 'pages/blog/low-conversion-rate';
import { frontmatter as meta40 } from 'pages/blog/error-rage-clicks';
import { frontmatter as meta41 } from 'pages/blog/inspect-mode';
import { frontmatter as meta42 } from 'pages/blog/7-psychological-principles-for-better-ux';

import { frontmatter as meta43 } from 'pages/blog/5-tips-for-better-a-b-tests';
import { frontmatter as meta44 } from 'pages/blog/advanced-session-sharing';
import { frontmatter as meta45 } from 'pages/blog/analyze-session-recordings';
import { frontmatter as meta46 } from 'pages/blog/autoplay';
import { frontmatter as meta47 } from 'pages/blog/cognitive-bias-ux';
import { frontmatter as meta48 } from 'pages/blog/cognitive-psychology-theories';
import { frontmatter as meta49 } from 'pages/blog/filtering-updates';
import { frontmatter as meta50 } from 'pages/blog/guide-to-qualitative-ux-research';
import { frontmatter as meta51 } from 'pages/blog/improving-customer-experience';
import { frontmatter as meta52 } from 'pages/blog/intercom-integration';
import { frontmatter as meta53 } from 'pages/blog/livesession-2019-summary';
import { frontmatter as meta54 } from 'pages/blog/livesession-badge';
import { frontmatter as meta55 } from 'pages/blog/livesession-sdk';
import { frontmatter as meta56 } from 'pages/blog/tips-for-new-product-managers-with-expert-quotes';
import { frontmatter as meta57 } from 'pages/blog/tips-to-improve-sign-up-forms-with-examples';
import { frontmatter as meta58 } from 'pages/blog/top-ux-events-in-cee';
import { frontmatter as meta59 } from 'pages/blog/tracking-customer-behavior';
import { frontmatter as meta60 } from 'pages/blog/user-roles';
import { frontmatter as meta61 } from 'pages/blog/ux-in-the-time-of-coronavirus';
import { frontmatter as meta62 } from 'pages/blog/winter-2019-livesession-named-a-g2-high-performer-again';
import { frontmatter as meta63 } from 'pages/blog/how-to-use-session-recordings-to-grow-your-saas';
import { frontmatter as meta64 } from 'pages/blog/5-ux-research-methods-for-the-remote-times';
import { frontmatter as meta65 } from 'pages/blog/how-to-use-data-analytics-to-improve-customer-support';
import { frontmatter as meta66 } from 'pages/blog/form-analytics';
import { frontmatter as meta67 } from 'pages/blog/clickmaps';
import { frontmatter as meta68 } from 'pages/blog/10-ui-tips-that-will-improve-your-ux-writing';
import { frontmatter as meta69 } from 'pages/blog/reasons-why-ux-should-be-a-priority-for-digital-marketers';
import { frontmatter as meta70 } from 'pages/blog/how-to-bring-old-content-back-to-life-and-discover-new-levels-of-engagement';
import { frontmatter as meta71 } from 'pages/blog/website-speed';
import { frontmatter as meta72 } from 'pages/blog/custom-events';
import { frontmatter as meta73 } from 'pages/blog/user-journey';
import { frontmatter as meta74 } from 'pages/blog/5-tips-to-create-best-ux-in-the-remote-work-culture';
import { frontmatter as meta75 } from 'pages/blog/segments-summary-email';
import { frontmatter as meta76 } from 'pages/blog/4-ways-to-improve-ecommerce-ux-for-website-visitors';
import { frontmatter as meta77 } from 'pages/blog/10-ways-to-increase-urgency-in-your-online-sales';
import { frontmatter as meta78 } from 'pages/blog/not-all-traffic-is-created-equally';
import { frontmatter as meta79 } from 'pages/blog/integration-with-livechat';
import { frontmatter as meta80 } from 'pages/blog/boost-websites-conversion-with-ux-improvements';
import { frontmatter as meta81 } from 'pages/blog/10-ux-tricks-to-improve-student-experience';
import { frontmatter as meta82 } from 'pages/blog/get-more-leads-this-year';
import { frontmatter as meta83 } from 'pages/blog/how-to-ab-test-saas-pricing-pages-in-2021';
import { frontmatter as meta84 } from 'pages/blog/rest-api';
import { frontmatter as meta85 } from 'pages/blog/funnels';
import { frontmatter as meta86 } from 'pages/blog/best-ux-practices-to-built-email-marketing-lists';
import { frontmatter as meta87 } from 'pages/blog/zendesk';
import { frontmatter as meta88 } from 'pages/blog/8-top-tactics-to-drive-customer-loyalty-through-your-website';
import { frontmatter as meta89 } from 'pages/blog/6-marketing-strategies-that-will-increase-your-conversions';

const posts = sortBy(
  [
    meta1,
    meta2,
    meta3,
    meta4,
    meta5,
    meta6,
    meta7,
    meta8,
    meta9,
    meta10,
    meta11,
    meta12,
    meta13,
    meta14,
    meta15,
    meta16,
    meta17,
    meta18,
    meta19,
    meta20,
    meta21,
    meta22,
    meta23,
    meta24,
    meta25,
    // meta26,
    meta27,
    meta28,
    meta29,
    meta30,
    meta31,
    meta32,
    meta33,
    meta34,
    meta35,
    meta36,
    meta37,
    meta38,
    meta39,
    meta40,
    meta41,
    meta42,
    meta43,
    meta44,
    meta45,
    meta46,
    meta47,
    meta48,
    meta49,
    meta50,
    meta51,
    meta52,
    meta53,
    meta54,
    meta55,
    meta56,
    meta57,
    meta58,
    meta59,
    meta60,
    meta61,
    meta62,
    meta63,
    meta64,
    meta65,
    meta66,
    meta67,
    meta68,
    meta69,
    meta70,
    meta71,
    meta72,
    meta73,
    meta74,
    meta75,
    meta76,
    meta77,
    meta78,
    meta79,
    meta80,
    meta81,
    meta82,
    meta83,
    meta84,
    meta85,
    meta86,
    meta87,
    meta88,
    meta89,
  ],
  (a) => -new Date(a.date),
);

export { posts };
